import { CommonEnums } from '../../common.enums';

export class Lkup_Inst_Cnd {
    lkup_Inst_Cnd_Id: number;
    lkup_Inst_Id: number;
    dxMp_Id: number;
    lkupType: string;
    secObjId: number;
    lkupCnd: string;
    valid_Cd: string;
    srt_Order: number;
    attr_Id: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.lkup_Inst_Cnd_Id = CommonEnums.defaults.LONG_VAL;
        this.lkup_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id == CommonEnums.defaults.LONG_VAL;
        this.lkupType = CommonEnums.defaults.STRING_EMPTY;
        this.secObjId = CommonEnums.defaults.LONG_VAL;
        this.lkupCnd = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
        this.attr_Id = CommonEnums.defaults.LONG_VAL;
    }

    static parse(lkup_Inst_CndTmp: any): Lkup_Inst_Cnd {
        let lkup_Inst_Cnd: Lkup_Inst_Cnd = new Lkup_Inst_Cnd();
        lkup_Inst_Cnd.copyFrom(lkup_Inst_CndTmp as Lkup_Inst_Cnd);
        return lkup_Inst_Cnd;
    }

    getPrimaryKey(): string {
        return this.dxMp_Id + '.' + this.lkup_Inst_Id + '.' + this.lkup_Inst_Cnd_Id;
    }

    copy(): Lkup_Inst_Cnd {
        let lkup_Inst_CndTmp: Lkup_Inst_Cnd = new Lkup_Inst_Cnd();

        lkup_Inst_CndTmp.lkup_Inst_Cnd_Id = this.lkup_Inst_Cnd_Id;
        lkup_Inst_CndTmp.lkup_Inst_Id = this.lkup_Inst_Id;
        lkup_Inst_CndTmp.dxMp_Id = this.dxMp_Id;
        lkup_Inst_CndTmp.lkupType = this.lkupType;
        lkup_Inst_CndTmp.secObjId = this.secObjId;
        lkup_Inst_CndTmp.lkupCnd = this.lkupCnd;
        lkup_Inst_CndTmp.valid_Cd = this.valid_Cd;
        lkup_Inst_CndTmp.srt_Order = this.srt_Order;
        lkup_Inst_CndTmp.attr_Id = this.attr_Id;

        return lkup_Inst_CndTmp;
    }

    copyFrom(lkup_Inst_CndTmp: Lkup_Inst_Cnd): void {
        this.lkup_Inst_Cnd_Id = lkup_Inst_CndTmp.lkup_Inst_Cnd_Id;
        this.lkup_Inst_Id = lkup_Inst_CndTmp.lkup_Inst_Id;
        this.dxMp_Id = lkup_Inst_CndTmp.dxMp_Id;
        this.lkupType = lkup_Inst_CndTmp.lkupType;
        this.secObjId = lkup_Inst_CndTmp.secObjId;
        this.lkupCnd = lkup_Inst_CndTmp.lkupCnd;
        this.valid_Cd = lkup_Inst_CndTmp.valid_Cd;
        this.srt_Order = lkup_Inst_CndTmp.srt_Order;
        this.attr_Id = lkup_Inst_CndTmp.attr_Id;
    }

    compare(lkup_Inst_CndTmp): string {
        let lkup_Inst_CndString: string = this.toString(false);
        let lkup_Inst_CndTmpString: string = lkup_Inst_CndTmp.toString(false);

        if (lkup_Inst_CndString != lkup_Inst_CndTmpString) {
            return lkup_Inst_CndString + ', ' + lkup_Inst_CndTmpString;
        }
        return '';
    }


    toString(isNotCompare: boolean = true): string {
        let str: string = "Lkup_Inst_Cnd [lkupt_Inst_Cnd_Id=" + this.lkup_Inst_Cnd_Id +
            ", lkup_Inst_Id=" + this.lkup_Inst_Id +
            ", dxMp_Id=" + this.dxMp_Id +
            ", lkupType=" + this.lkupType +
            ", secObjId=" + this.secObjId +
            ", lkupCnd=" + this.lkupCnd +
            ", valid_Cd=" + this.valid_Cd +
            ", srt_Order=" + this.srt_Order +
            ", attr_Id=" + this.attr_Id;

        if (isNotCompare) {
            str += ''
        }

        str += ']';
        return str;
    }
}	